import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Title, Text, Select, Button, Group } from '@mantine/core'
import { getOrgUsers, updateUserRole } from '../services/actions/userActions'

const EditUserPage = () => {
	const { userId } = useParams()
	const [user, setUser] = useState(null)
	const [role, setRole] = useState('')
	const [error, setError] = useState('')
	const navigate = useNavigate()

	useEffect(() => {
		const fetchUser = async () => {
			try {
				const users = await getOrgUsers()
				const selectedUser = users.find((u) => u.id === userId)

				if (!selectedUser) {
					setError('User not found')
					return
				}

				setUser(selectedUser)
				setRole((selectedUser.role || '').toLowerCase())
			} catch (err) {
				console.error('Failed to fetch user:', err)
				setError('Failed to fetch user')
			}
		}

		fetchUser()
	}, [userId])

	const handleSave = async () => {
		try {
			await updateUserRole(userId, role)
			navigate('/admin/users')
		} catch (err) {
			console.error('Failed to update user role:', err)
			setError('Failed to update user role')
		}
	}

	if (error) return <Text color='red'>{error}</Text>
	if (!user) return <Text>Loading...</Text>

	return (
		<Box px='md' py='md'>
			<Title order={2} mb='md'>
				Edit User
			</Title>

			<Text>
				<strong>Name:</strong> {user.name}
			</Text>
			<Text mb='sm'>
				<strong>Email:</strong> {user.email}
			</Text>

			<Select
				label='Role'
				value={role}
				onChange={setRole}
				data={[
					{ value: 'user', label: 'User' },
					{ value: 'admin', label: 'Admin' },
				]}
				mb='md'
			/>

			<Group mt='md'>
				<Button onClick={handleSave}>Save</Button>
				<Button
					variant='light'
					color='gray'
					onClick={() => navigate('/admin/users')}
				>
					Cancel
				</Button>
			</Group>
		</Box>
	)
}

export default EditUserPage
